module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Terminate Automatic Backups","introduction":["Are you sure you want to terminate your automatic backups?","You will have to reconfigure them again from scratch to start them again, and this action cannot be undone."]}}')
  delete Component.options._Ctor
}
